
export interface NameId {
    name: string;
    id: string;
}
export const PAGES: NameId[] = [
    {name: "Question types", id: "player"},
    {name: "Authoring tool", id: "editor"},
    {name: "Formula editor", id: "formula-editor"}
]

export interface ThemeSpec {
    name: string;
    id: string;
}
export const THEMES: ThemeSpec[] = [{
    name: 'Algebrakit',
    id: 'akit'
}, {
    name: 'theme 1',
    id: 'hodder'
}, {
    name: 'theme 2',
    id: 'teelen'
}]
